// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__mfF5R","label":"SetPasswdForm_label__2Qjpb"};